import leadsApi from '../../api/leads'

const state = {
  leadDetails: {},
  selectedVehicleModel: {},
  citiesList: [],
  licensePlateRegex: /^(AB|AG|AR|B|BC|BH|BN|BR|BT|BV|BZ|CJ|CL|CS|CT|CV|DB|DJ|GJ|GL|GR|HD|HR|IF|IL|IS|MH|MM|MS|NT|OT|PH|SB|SJ|SM|SV|TL|TM|TR|VL|VN|VS)[-\s]*(((0[1-9]|[1-9][0-9]|[1-9][0-9]{2})[-\s]*([A-Z]{3}))|([0-9]{5,6}))$/,
  fleetsList: [
    { name: 'Taxi', value: 'taxi' },
    { name: 'Ridesharing', value: 'phv' }
  ],
  vehicleModelsList: [],
  dispatchesList: [],
  driverDocumentsList: [],
  driverDocumentsUploaded: {},
  vehicleDocumentsList: [],
  vehicleDocumentsUploaded: {}
}

const getters = {
  leadDetails: state => state.leadDetails,
  selectedVehicleModel: state => state.selectedVehicleModel,
  citiesList: state => state.citiesList,
  fleetsList: state => state.fleetsList,
  vehicleModelsList: state => state.vehicleModelsList,
  dispatchesList: state => state.dispatchesList,
  driverDocumentsList: state => state.driverDocumentsList,
  vehicleDocumentsList: state => state.vehicleDocumentsList,
  driverDocumentsUploaded: state => state.driverDocumentsUploaded,
  licensePlateRegex: state => state.licensePlateRegex,
  vehicleDocumentsUploaded: state => state.vehicleDocumentsUploaded,
  documentsRequiredCount: (state) => (target) => {
    let list = []
    switch (target) {
      case 'driver': list = state.driverDocumentsList; break
      case 'vehicle': list = state.vehicleDocumentsList; break
    }
    return list.reduce(function (acc, document) {
      return acc + (document.required === true)
    }, 0)
  },
  documentsAllRequiredUploaded: (state) => (target) => {
    let list = []
    let uploaded = {}
    switch (target) {
      case 'driver':
        list = state.driverDocumentsList
        uploaded = state.driverDocumentsUploaded
        break
      case 'vehicle':
        list = state.vehicleDocumentsList
        uploaded = state.vehicleDocumentsUploaded
        break
    }

    return list.reduce(function (acc, document) {
      if (!document.required) {
        return acc
      }
      return acc && uploaded.hasOwnProperty(document.type)
    }, true)
  },
  validLicenseNumber: (state) => (licenseNumber) => {
    if (typeof licenseNumber === 'undefined' || !licenseNumber) {
      return null
    }
    const SEP = '-'
    const m = licenseNumber.match(state.licensePlateRegex)
    if (!m) {
      return null
    }

    let valid = m[1]
    if (typeof m[6] !== 'undefined' && m[6]) {
      valid += SEP + m[6]
    } else {
      valid += SEP + m[4] + SEP + m[5]
    }
    return valid
  }
}

const actions = {
  create ({ commit }, { data, onsuccess, onerror }) {
    leadsApi.create(data, (response) => {
      commit('saveLeadDetails', { data: response.lead })
      onsuccess(response.lead)
    }, (error) => {
      onerror(error)
    })
  },
  saveDriverDetails ({ commit }, { data, onsuccess, onerror }) {
    leadsApi.saveDriverDetails(data, (response) => {
      commit('saveLeadDetails', { data: response.lead })
      onsuccess(response.lead)
    }, (error) => {
      onerror(error)
    })
  },
  saveDriverDocument ({ commit }, { data, onsuccess, onerror }) {
    leadsApi.saveDocument(data, (response) => {
      commit('saveUploadedDriverDocument', { data: response })
      onsuccess(data)
    }, (error) => {
      onerror(error)
    })
  },
  saveVehicleDocument ({ commit }, { data, onsuccess, onerror }) {
    leadsApi.saveDocument(data, (response) => {
      commit('saveUploadedVehicleDocument', { data: response })
      onsuccess(data)
    }, (error) => {
      onerror(error)
    })
  },
  saveVehicleDetails ({ commit }, { data, onsuccess, onerror }) {
    leadsApi.saveVehicleDetails(data, (response) => {
      commit('saveLeadDetails', { data: response.lead })
      onsuccess(response.lead)
    }, (error) => {
      onerror(error)
    })
  },
  finishOnboarding ({ commit }, { onsuccess, onerror }) {
    leadsApi.finishOnboarding((response) => {
      commit('saveLeadDetails', { data: response.lead })
      onsuccess()
    }, (error) => {
      onerror(error)
    })
  },
  getCities ({ commit, state }, { data, onsuccess, onerror }) {
    leadsApi.getCities(data, (response) => {
      commit('saveCitiesList', { data: response })
      onsuccess(response)
    }, (error) => {
      onerror(error)
    })
  },
  getVehicleModels ({ commit }, { data, onsuccess, onerror }) {
    leadsApi.getVehicleModels(data, (response) => {
      const vehicleModels = response.map(element => {
        return {
          id: element.id,
          name: `${element.manufacturer.name} ${element.name}`
        }
      })
      commit('saveVehicleModelsList', { data: vehicleModels })
      onsuccess(data)
    }, (error) => {
      onerror(error)
    })
  },
  getTaxiDispatches ({ commit }, { data, onsuccess, onerror }) {
    leadsApi.getTaxiDispatches(data, (response) => {
      commit('saveTaxiDispatchesList', { data: response })
      onsuccess(data)
    }, (error) => {
      onerror(error)
    })
  },
  getDocuments ({ commit }, { data, onsuccess, onerror }) {
    leadsApi.getDocuments(data, (response) => {
      commit('saveDriverDocumentsList', { data: response.driver })
      commit('saveVehicleDocumentsList', { data: response.vehicle })
      onsuccess(data)
    }, (error) => {
      onerror(error)
    })
  },
  getPrivacyInfo ({ commit }, { onsuccess, onerror }) {
    leadsApi.getPrivacyInfo((response) => {
      onsuccess(response)
    }, (error) => {
      onerror(error)
    })
  },
  updateBankAccount ({ commit }, { data, onsuccess, onerror }) {
    leadsApi.updateBankAccount(data, (response) => {
      onsuccess(response)
    }, (error) => {
      onerror(error)
    })
  }
}

const mutations = {
  saveLeadDetails (state, data) {
    state.leadDetails = Object.assign({}, state.leadDetails, data.data)
  },
  saveCitiesList (state, data) {
    state.citiesList = data.data
  },
  saveVehicleModelsList (state, data) {
    state.vehicleModelsList = data.data
  },
  saveSelectedVehicleModel (state, data) {
    state.selectedVehicleModel = data
  },
  saveDriverDocumentsList (state, data) {
    state.driverDocumentsList = data.data
  },
  saveVehicleDocumentsList (state, data) {
    state.vehicleDocumentsList = data.data
  },
  saveTaxiDispatchesList (state, data) {
    state.dispatchesList = data.data
  },
  saveUploadedDriverDocument (state, data) {
    state.driverDocumentsUploaded[data.data.type] = data.data
  },
  saveUploadedVehicleDocument (state, data) {
    state.vehicleDocumentsUploaded[data.data.type] = data.data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
